module.exports = __webpack_public_path__ + "static/media/campeonato_01.dec934f8.jpg";